import { type Debugger } from 'debug';

import { ILogger, IUserBiLog } from './abstractions';
import OneDsTelemetry from './OneDsTelemetry';

export class Logger implements ILogger {
  readonly trace: Debugger;
  readonly log: Debugger;
  readonly warn: Debugger;
  readonly error: Debugger;
  constructor({
    trace,
    log,
    warn,
    error,
  }: {
    trace: Debugger;
    log: Debugger;
    warn: Debugger;
    error: Debugger;
  }) {
    this.trace = trace;
    this.log = log;
    this.warn = warn;
    this.error = error;
  }

  logUserBi(eventData: IUserBiLog) {
    OneDsTelemetry.logUserBi(eventData);
  };

  setUserInfo(tenantId: string | null, aadId: string | null) {
    OneDsTelemetry.setUserInfo(tenantId, aadId);
  }

  extend(namespace: string) {
    return new Logger({
      trace: this.trace.extend(namespace),
      log: this.log.extend(namespace),
      warn: this.warn.extend(namespace),
      error: this.error.extend(namespace),
    });
  }
}
